import { GradientPill, Icons } from '@vertex-protocol/web-ui';

export function NewPill() {
  return (
    <GradientPill colorVariant="alt" icon={Icons.SparkleFill}>
      NEW
    </GradientPill>
  );
}
